import Icon from 'veui/components/Icon'

Icon.register({
  speaker: {
    paths: [
      {
        d: 'M528.19 36.4a32 32 0 00-31.8-.33L215.66 193H64a32 32 0 00-32 32v319a32 32 0 0032 32h151.71l280.75 156A32 32 0 00544 704V64a32 32 0 00-15.81-27.6zM96 257h96v255H96zm384 392.62L256 525.17v-281.4l224-125.22zM736 384c0 83.36-24.06 162.64-69.58 229.28a32 32 0 11-52.84-36.09C651.8 521.23 672 454.42 672 384s-20.2-137.23-58.42-193.19a32 32 0 1152.84-36.09C711.94 221.36 736 300.64 736 384z'
      }
    ],
    width: '768',
    height: '768'
  }
})
